export default __webpack_public_path__ + "static/media/why-choose4.ca830d7d.png";